import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { deleteSubscriptionAction } from 'src/redux/actions/subscriptionActions';

const DeleteSubscriptionDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteSubscription]) {
        return state.dialog[DIALOGS.deleteSubscription];
      }
      return { opened: false, payload: null };
    });
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_subscription] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteSubscription }));
  };

  const handleOk = () => {
    const { subscriptionId } = payload;
    dispatch(deleteSubscriptionAction(subscriptionId));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-subscription"
      open={opened}>
      <DialogTitle id="deleting-subscription">
        {t(lang, 'menus.delete_subscription')}
      </DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.delete_subscription_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSubscriptionDialog;
